import { Http } from "../../utilities/axios/http";

export class GlobalRequest {
  static get = async (uri: string, params?: any) => {
    try {
      return Http.get(uri, params);
    } catch (error) {
      return error;
    }
  };
}
